
import bootstrap from "./bootstrap";
window.login = function(node, config) {
  bootstrap(node, config);
}